module.exports = __webpack_public_path__ + "img/newsImg7-1.083aa700.png";